export default "__VITE_ASSET__47a1d534__"